<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import Vue from "vue";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
    "$i18n.locale"() {
      this.routeTitle = this.$t(this.$route.meta.pageTitle);

      if (this.routeTitle)
        document.title = this.routeTitle + " | " + this.$t("PageTitle");
      else document.title = this.$t("PageTitle");

      this.$misc.emit("localeEvent");
    },
  },
  async created() {
    try {
      let dir = this.$vs.rtl ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", dir);
      window.addEventListener("resize", this.handleWindowResize);
      window.addEventListener("scroll", this.handleScroll);

      // await this.$auth.renewTokens();
      // Vue.prototype.startSignalR(this.$store.state.auth.userInfo().token);
      // this.$signalr.$on("SoldRentArea", this.soldRentArea);
      // this.$signalr.$on("SoldRentAreaAuth", this.soldRentAreaAuth);
      // this.$signalr.$on("SoldRentAreaNewAuth", this.soldRentAreaNewAuth);
    } catch (e) {}
  },
  methods: {
    handleLoginEvent(payload) {
      // if (payload.loggedIn) {
      //   this.$router.push("/");
      // } else {
      //   this.$router.push("/login");
      // }
    },
    soldRentArea(rentArea) {
      this.$store.dispatch("rent/soldPointer", rentArea);
    },
    soldRentAreaAuth(rentArea) {
      this.$store.dispatch("rent/soldAuthPointer", rentArea);
    },
    soldRentAreaNewAuth(rentArea) {
      this.$store.dispatch("rent/addAuthPointer", rentArea);
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    // this.$signalr.$off("SoldRentArea", this.soldRentArea);
    // this.$signalr.$off("SoldRentAreaAuth", this.soldRentAreaAuth);
    // this.$signalr.$off("SoldRentAreaNewAuth", this.soldRentAreaNewAuth);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
